import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";

import Landing from "@/pages/Landing";
import AuthPage from "@/pages/AuthPage";
import Dashboard from "@/pages/Dashboard";
import Profil from "@/pages/Profil";
import Erfarenheter from "@/pages/Erfarenheter";
import Utbildning from "@/pages/Utbildning";
import Kompetenser from "@/pages/Kompetenser";
import SystemVerktyg from "@/pages/SystemVerktyg";
import Intyg from "@/pages/Intyg";
import Karaktar from "@/pages/Karaktar";
import Intressen from "@/pages/Intressen";
import Riktning from "@/pages/Riktning";
import Vagledning from "@/pages/Vagledning";
import PersonligtBrev from "@/pages/PersonligtBrev";
import Referenser from "@/pages/Referenser";
import SkapaCV from "@/pages/SkapaCV";
import MinaCV from "@/pages/MinaCV";
import CVEditor from "@/pages/CVEditor";
import CVPrint from "@/pages/CVPrint";
import Dokument from "@/pages/Dokument";
import Installningar from "@/pages/Installningar";
import ReferensSvar from "@/pages/ReferensSvar";
import AdminPanel from "@/pages/AdminPanel";
import ImporteraCV from "@/pages/ImporteraCV";
import Intervju from "@/pages/Intervju";
import IntervjuDelad from "@/pages/IntervjuDelad";
import Ansokningar from "@/pages/Ansokningar";
import Underlag from "@/pages/Underlag";
import UnderlagDelad from "@/pages/UnderlagDelad";
import GlomtLosenord from "@/pages/GlomtLosenord";
import AterstallLosenord from "@/pages/AterstallLosenord";
import Feedback from "@/pages/Feedback";
import HjalpPublik from "@/pages/HjalpPublik";
import Integritetspolicy from "@/pages/Integritetspolicy";
import SaFunkarDet from "@/pages/SaFunkarDet";
import EmployerLayout from "@/components/EmployerLayout";
import ForetagSok from "@/pages/ForetagSok";
import ForetagSparade from "@/pages/ForetagSparade";
import ForetagMeddelanden from "@/pages/ForetagMeddelanden";
import Meddelanden from "@/pages/Meddelanden";
import PaymentResult from "@/pages/PaymentResult";
import CookieConsent from "@/components/CookieConsent";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<AuthPage mode="login" />} />
            <Route path="/register" element={<AuthPage mode="register" />} />
            <Route path="/foretag/logga-in" element={<AuthPage mode="login" userType="employer" />} />
            <Route path="/foretag/registrera" element={<AuthPage mode="register" userType="employer" />} />
            <Route path="/referens/:token" element={<ReferensSvar />} />
            <Route path="/glomt-losenord" element={<GlomtLosenord />} />
            <Route path="/aterstall-losenord/:token" element={<AterstallLosenord />} />
            <Route path="/hjalp" element={<HjalpPublik />} />
            <Route path="/integritetspolicy" element={<Integritetspolicy />} />
            <Route path="/sa-funkar-det" element={<SaFunkarDet />} />
            <Route path="/underlag/delad/:token" element={<UnderlagDelad />} />
            <Route path="/intervju/:token" element={<IntervjuDelad />} />

            <Route path="/cv-print/:id" element={<ProtectedRoute><CVPrint /></ProtectedRoute>} />
            <Route path="/betalning/klar" element={<ProtectedRoute><PaymentResult /></ProtectedRoute>} />
            <Route path="/betalning/avbruten" element={<ProtectedRoute><PaymentResult cancelled /></ProtectedRoute>} />

            <Route path="/app" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
              <Route index element={<Dashboard />} />
              <Route path="profil" element={<Profil />} />
              <Route path="importera-cv" element={<ImporteraCV />} />
              <Route path="erfarenheter" element={<Erfarenheter />} />
              <Route path="utbildning" element={<Utbildning />} />
              <Route path="kompetenser" element={<Kompetenser />} />
              <Route path="system" element={<SystemVerktyg />} />
              <Route path="intyg" element={<Intyg />} />
              <Route path="karaktar" element={<Karaktar />} />
              <Route path="intervju" element={<Intervju />} />
              <Route path="intressen" element={<Intressen />} />
              <Route path="riktning" element={<Riktning />} />
              <Route path="vagledning" element={<Vagledning />} />
              <Route path="referenser" element={<Referenser />} />
              <Route path="ansokningar" element={<Ansokningar />} />
              <Route path="underlag" element={<Underlag />} />
              <Route path="skapa-cv" element={<SkapaCV />} />
              <Route path="personligt-brev" element={<PersonligtBrev />} />
              <Route path="meddelanden" element={<Meddelanden />} />
              <Route path="cv" element={<MinaCV />} />
              <Route path="cv/:id" element={<CVEditor />} />
              <Route path="dokument" element={<Dokument />} />
              <Route path="installningar" element={<Installningar />} />
              <Route path="feedback" element={<Feedback />} />
              <Route path="admin" element={<AdminPanel />} />
            </Route>

            <Route path="/foretag" element={<EmployerLayout />}>
              <Route index element={<ForetagSok />} />
              <Route path="sparade" element={<ForetagSparade />} />
              <Route path="meddelanden" element={<ForetagMeddelanden />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <CookieConsent />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
